import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from '../Icon';

import './styles.less';

class Navbar extends Component {
    constructor(props) {
        super(props);
        this.state = { selectedItem: '' };
    }

    //Check items array prop for specified active item
    componentWillMount() {
        this.props.items.forEach((item) => {
            if (item.isActive) {
                this.setState({ selectedItem: item.title });
            }
        });
    }

    updateSelectedItem(title) {
        this.setState({ selectedItem: title });
        this.props.items.forEach((item) => {
            if (item.title === this.state.selectedItem) {
                item.isActive = true;
            } else {
                item.isActive = false;
            }
        });
    }

    renderNavItem(item) {
        return (
            <li
                className={classNames(
                    'p-navbar__nav-item',
                    item.title === this.state.selectedItem && 'p-navbar__nav-item--active',
                    item.isHiddenInApp && 'u-app-hide'
                )}
                data-pb-expires={item.expires || null}
                key={item.title}
            >
                <a
                    className="p-navbar__nav-link u-text-h4"
                    href={item.url}
                    target={item.openInNewTab ? '_blank' : '_self'}
                    data-phone-href={item.mobileUrl || ''}
                    data-cid={item.contentId}
                    onClick={() => this.updateSelectedItem(item.title)}
                >
                    {item.titleShort ? <span className="p-navbar__title-short">{item.titleShort}</span> : ''}
                    <span className="p-navbar__title">{item.title}</span>
                </a>
            </li>
        );
    }

    render() {
        return (
            <div
                className={classNames(
                    'p-navbar',
                    !this.props.scrollable ? 'p-navbar--collapsible' : '',
                    this.props.alwaysCollapsed && 'p-navbar--always-collapsed',
                    this.props.mini && 'p-navbar--mini'
                )}
                data-cid={this.props.contentId}
            >
                <input className="p-navbar__actual-checkbox" type="checkbox" />
                <ul className="p-navbar__nav-list">{this.props.items.map((item) => this.renderNavItem(item))}</ul>
                <div className="p-navbar__icon-container">
                    <Icon className="p-navbar__icon p-navbar__icon--expand" icon="arrow-expand" size="sm" />
                    <Icon className="p-navbar__icon p-navbar__icon--contract" icon="arrow-contract" size="sm" />
                </div>
            </div>
        );
    }
}

Navbar.propTypes = {
    mini: PropTypes.bool,
    alwaysCollapsed: PropTypes.bool,
    contentId: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.shape({ title: PropTypes.string, url: PropTypes.string })).isRequired,
    scrollable: PropTypes.bool
};

Navbar.defaultProps = {
    scrollable: false,
    mini: false,
    contentId: undefined,
    alwaysCollapsed: false
};

export default Navbar;
